/* ============================================================
   AURAPEAKS CE — theme.js
   AJAX cart drawer + nav + reveals. No dependencies.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Money formatting ---------- */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1])
      .replace(/<[^>]*>/g, '');
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var drawerBody = document.querySelector('[data-cart-body]');
  var drawerFoot = document.querySelector('[data-cart-foot]');
  var subtotalEl = document.querySelector('[data-cart-subtotal]');
  var countEls = document.querySelectorAll('[data-cart-count]');

  function openDrawer() {
    document.body.classList.add('cart-open');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer() {
    document.body.classList.remove('cart-open');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart().then(openDrawer); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function refreshCart() {
    return fetch(window.theme.cartUrl + '.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function renderCart(cart) {
    countEls.forEach(function (el) { el.textContent = cart.item_count; });
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
    if (!drawerBody) return cart;

    if (cart.item_count === 0) {
      drawerBody.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<p><strong>Your cart is empty.</strong></p>' +
        '<p>Charge it up.</p>' +
        '<a class="btn btn--volt" href="/collections/all" data-cart-close>Shop CE \u26A1</a>' +
        '</div>';
      if (drawerFoot) drawerFoot.style.display = 'none';
      return cart;
    }

    if (drawerFoot) drawerFoot.style.display = '';
    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image
        ? item.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_180x$1$2')
        : '';
      html +=
        '<div class="cart-line" data-line-key="' + item.key + '">' +
          (img ? '<img class="cart-line__img" src="' + img + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '<div class="cart-line__img"></div>') +
          '<div>' +
            '<p class="cart-line__title">' + escapeHtml(item.product_title) + '</p>' +
            (item.variant_title && item.variant_title !== 'Default Title'
              ? '<p class="cart-line__variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
            '<div class="cart-line__qty" aria-label="Quantity">' +
              '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">\u2212</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-qty-remove>Remove</button>' +
          '</div>' +
          '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>';
    });
    drawerBody.innerHTML = html;
    return cart;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  /* Quantity change / remove inside drawer */
  document.addEventListener('click', function (e) {
    var changeBtn = e.target.closest('[data-qty-change]');
    var removeBtn = e.target.closest('[data-qty-remove]');
    if (!changeBtn && !removeBtn) return;

    var line = e.target.closest('[data-line-key]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var qty = 0;

    if (changeBtn) {
      var current = parseInt(line.querySelector('.cart-line__qty span').textContent, 10) || 0;
      qty = Math.max(0, current + parseInt(changeBtn.getAttribute('data-qty-change'), 10));
    }

    fetch(window.theme.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  });

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var originalText = button ? button.innerHTML : '';
    if (button) { button.innerHTML = 'Adding\u2026'; button.disabled = true; }

    fetch(window.theme.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add-failed');
        return r.json();
      })
      .then(function () { return refreshCart(); })
      .then(function () {
        if (button) { button.innerHTML = 'Added \u26A1'; }
        openDrawer();
        setTimeout(function () {
          if (button) { button.innerHTML = originalText; button.disabled = false; }
        }, 1200);
      })
      .catch(function () {
        if (button) { button.innerHTML = 'Sold out / unavailable'; button.disabled = false; }
        setTimeout(function () { if (button) button.innerHTML = originalText; }, 2000);
      });
  });

  /* ---------- Generic quantity steppers (buy box / product page) ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('.qty');
    var input = wrap && wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    var val = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10));
    input.value = val;
  });

  /* ---------- Mobile nav ---------- */
  var burger = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Scroll reveals ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Initial cart count ---------- */
  refreshCart();
})();
